/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AggregatedRDataSpecialtyPracticeViewModel } from '../models/aggregated-r-data-specialty-practice-view-model';
import { GetAggregatedRDataSpecialtyPracticeRequest } from '../models/get-aggregated-r-data-specialty-practice-request';
import { ListRDataItemSortBy } from '../models/list-r-data-item-sort-by';
import { PositionType } from '../models/position-type';
import { PracticeType } from '../models/practice-type';
import { RDataPracticeViewModel } from '../models/r-data-practice-view-model';
import { RDataPracticeViewModelPaginatedItemsViewModel } from '../models/r-data-practice-view-model-paginated-items-view-model';
import { Region } from '../models/region';
import { SortOrder } from '../models/sort-order';

@Injectable({
  providedIn: 'root',
})
export class RDataPracticeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation compensationApiPracticeRdataListGet
   */
  static readonly CompensationApiPracticeRdataListGetPath = '/compensation-api/practice/rdata/list';

  /**
   * Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataListGet$Plain$Response(params?: {
    Specialties?: Array<string>;
    Academic?: boolean;
    Verified?: boolean;
    StateAbbreviations?: Array<string>;
    PositionType?: PositionType;
    PracticeTypes?: Array<PracticeType>;
    Region?: Region;
    PageSize?: number;
    PageNumber?: number;
    SortBy?: ListRDataItemSortBy;
    SortOrder?: SortOrder;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataListGetPath, 'get');
    if (params) {
      rb.query('Specialties', params.Specialties, {});
      rb.query('Academic', params.Academic, {});
      rb.query('Verified', params.Verified, {});
      rb.query('StateAbbreviations', params.StateAbbreviations, {});
      rb.query('PositionType', params.PositionType, {});
      rb.query('PracticeTypes', params.PracticeTypes, {});
      rb.query('Region', params.Region, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('PageNumber', params.PageNumber, {});
      rb.query('SortBy', params.SortBy, {});
      rb.query('SortOrder', params.SortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>;
      })
    );
  }

  /**
   * Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataListGet$Plain(params?: {
    Specialties?: Array<string>;
    Academic?: boolean;
    Verified?: boolean;
    StateAbbreviations?: Array<string>;
    PositionType?: PositionType;
    PracticeTypes?: Array<PracticeType>;
    Region?: Region;
    PageSize?: number;
    PageNumber?: number;
    SortBy?: ListRDataItemSortBy;
    SortOrder?: SortOrder;
  },
  context?: HttpContext

): Observable<RDataPracticeViewModelPaginatedItemsViewModel> {

    return this.compensationApiPracticeRdataListGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>) => r.body as RDataPracticeViewModelPaginatedItemsViewModel)
    );
  }

  /**
   * Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataListGet$Json$Response(params?: {
    Specialties?: Array<string>;
    Academic?: boolean;
    Verified?: boolean;
    StateAbbreviations?: Array<string>;
    PositionType?: PositionType;
    PracticeTypes?: Array<PracticeType>;
    Region?: Region;
    PageSize?: number;
    PageNumber?: number;
    SortBy?: ListRDataItemSortBy;
    SortOrder?: SortOrder;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataListGetPath, 'get');
    if (params) {
      rb.query('Specialties', params.Specialties, {});
      rb.query('Academic', params.Academic, {});
      rb.query('Verified', params.Verified, {});
      rb.query('StateAbbreviations', params.StateAbbreviations, {});
      rb.query('PositionType', params.PositionType, {});
      rb.query('PracticeTypes', params.PracticeTypes, {});
      rb.query('Region', params.Region, {});
      rb.query('PageSize', params.PageSize, {});
      rb.query('PageNumber', params.PageNumber, {});
      rb.query('SortBy', params.SortBy, {});
      rb.query('SortOrder', params.SortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>;
      })
    );
  }

  /**
   * Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataListGet$Json(params?: {
    Specialties?: Array<string>;
    Academic?: boolean;
    Verified?: boolean;
    StateAbbreviations?: Array<string>;
    PositionType?: PositionType;
    PracticeTypes?: Array<PracticeType>;
    Region?: Region;
    PageSize?: number;
    PageNumber?: number;
    SortBy?: ListRDataItemSortBy;
    SortOrder?: SortOrder;
  },
  context?: HttpContext

): Observable<RDataPracticeViewModelPaginatedItemsViewModel> {

    return this.compensationApiPracticeRdataListGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<RDataPracticeViewModelPaginatedItemsViewModel>) => r.body as RDataPracticeViewModelPaginatedItemsViewModel)
    );
  }

  /**
   * Path part for operation compensationApiPracticeRdataIdGet
   */
  static readonly CompensationApiPracticeRdataIdGetPath = '/compensation-api/practice/rdata/{id}';

  /**
   * Gets the practice rData details for the specified rData id. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataIdGet$Plain$Response(params: {

    /**
     * The rData uuid.
     */
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RDataPracticeViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RDataPracticeViewModel>;
      })
    );
  }

  /**
   * Gets the practice rData details for the specified rData id. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataIdGet$Plain(params: {

    /**
     * The rData uuid.
     */
    id: string;
  },
  context?: HttpContext

): Observable<RDataPracticeViewModel> {

    return this.compensationApiPracticeRdataIdGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<RDataPracticeViewModel>) => r.body as RDataPracticeViewModel)
    );
  }

  /**
   * Gets the practice rData details for the specified rData id. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataIdGet$Json$Response(params: {

    /**
     * The rData uuid.
     */
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<RDataPracticeViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RDataPracticeViewModel>;
      })
    );
  }

  /**
   * Gets the practice rData details for the specified rData id. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  compensationApiPracticeRdataIdGet$Json(params: {

    /**
     * The rData uuid.
     */
    id: string;
  },
  context?: HttpContext

): Observable<RDataPracticeViewModel> {

    return this.compensationApiPracticeRdataIdGet$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<RDataPracticeViewModel>) => r.body as RDataPracticeViewModel)
    );
  }

  /**
   * Path part for operation compensationApiPracticeRdataAggregatesPost
   */
  static readonly CompensationApiPracticeRdataAggregatesPostPath = '/compensation-api/practice/rdata/aggregates';

  /**
   * Fetch aggregated rData. The user needs a sign in to get it, and needs rData read access to look at regional aggregates. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataAggregatesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  compensationApiPracticeRdataAggregatesPost$Plain$Response(params?: {

    /**
     * The request containing the values to be scored.
     */
    body?: GetAggregatedRDataSpecialtyPracticeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataAggregatesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>;
      })
    );
  }

  /**
   * Fetch aggregated rData. The user needs a sign in to get it, and needs rData read access to look at regional aggregates. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataAggregatesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  compensationApiPracticeRdataAggregatesPost$Plain(params?: {

    /**
     * The request containing the values to be scored.
     */
    body?: GetAggregatedRDataSpecialtyPracticeRequest
  },
  context?: HttpContext

): Observable<AggregatedRDataSpecialtyPracticeViewModel> {

    return this.compensationApiPracticeRdataAggregatesPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>) => r.body as AggregatedRDataSpecialtyPracticeViewModel)
    );
  }

  /**
   * Fetch aggregated rData. The user needs a sign in to get it, and needs rData read access to look at regional aggregates. Required scopes: [api.read].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `compensationApiPracticeRdataAggregatesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  compensationApiPracticeRdataAggregatesPost$Json$Response(params?: {

    /**
     * The request containing the values to be scored.
     */
    body?: GetAggregatedRDataSpecialtyPracticeRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>> {

    const rb = new RequestBuilder(this.rootUrl, RDataPracticeService.CompensationApiPracticeRdataAggregatesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>;
      })
    );
  }

  /**
   * Fetch aggregated rData. The user needs a sign in to get it, and needs rData read access to look at regional aggregates. Required scopes: [api.read].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `compensationApiPracticeRdataAggregatesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  compensationApiPracticeRdataAggregatesPost$Json(params?: {

    /**
     * The request containing the values to be scored.
     */
    body?: GetAggregatedRDataSpecialtyPracticeRequest
  },
  context?: HttpContext

): Observable<AggregatedRDataSpecialtyPracticeViewModel> {

    return this.compensationApiPracticeRdataAggregatesPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<AggregatedRDataSpecialtyPracticeViewModel>) => r.body as AggregatedRDataSpecialtyPracticeViewModel)
    );
  }

}
